import logo from "./logo.svg";
import "./App.css";
import Routes from "./Routes";
import Store from "./redux/store";
import { Provider, useSelector } from "react-redux";

import {
  ThemeProvider,
  createMuiTheme,
  CircularProgress,
  Divider,
} from "@material-ui/core";
import fontConfig from "./constants/fonts";
import { BrowserRouter } from "react-router-dom";

function App() {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#3B79B2",
      },
      secondary: {
        main: "#FE9901",
      },
    },
    shape: {
      borderRadius: 10,
    },
    typography: {
      fontFamily: fontConfig.regular.fontFamily,
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
      },
    },
  });
  return (
    <BrowserRouter>
      <div className="App">
        <Provider store={Store()}>
          <ThemeProvider theme={theme}>
            <Routes />
          </ThemeProvider>
        </Provider>
      </div>
    </BrowserRouter>
  );
}

export default App;
